import {HeaderTabs} from "../../../Layout/HeaderTabs";
import {
  Alert,
  Anchor, Badge, Box,
  Breadcrumbs,
  Button,
  Card,
  Container,
  Flex,
  Group,
  Image,
  Loader, rem,
  ScrollArea,
  SimpleGrid, Text, Title
} from "@mantine/core";
import {Link, useParams} from "react-router-dom";
import React from "react";
import useGalleries from "../hooks/useGalleries";
import GalleryCard from "../list/GalleryCard";
import useGalleryPhotos from "../hooks/useGalleryPhotos";
import {IconInfoCircle} from "@tabler/icons-react";
import CreateModal from "../Create/CreateModal";
import useGallery from "../hooks/useGallery";
import EmptyState from "../../../Shared/EmptyState";
import PhotoAlbumView from "./PhotoAlbumView";
import VideoRow from "./VideoRow";
import {useSelection} from "./Move/useSelection";
import MoveModal from "./Move/MoveModal";
import moveClasses from "./Move/move.module.css";
import {useDisclosure} from "@mantine/hooks";

const GalleryDetail = () => {


  const params = useParams()
  const id = params.id ? parseInt(params.id) : null

  const {gallery} = useGallery(id)
  const {gallery: upGallery} = useGallery(gallery?.upper_gallery ?? null)

  const photos = useGalleryPhotos(id)

  const selection = useSelection()
  const [moveOpened, {open: openMove, close: closeMove}] = useDisclosure(false)


  return (
    <>
      <HeaderTabs/>
      <Container size="md" mb={20}>
        <Breadcrumbs mb={10}>
          <Link to="/" key={"A"}><Anchor>Dashboard</Anchor></Link>
          <Link to="/galeries" key={"T"}><Anchor>Galerie</Anchor></Link>

          {upGallery ? (
            <Link to={`/galeries/${upGallery?.id}`} key={"TITLE"}>
              <Anchor>{upGallery?.title} ({upGallery?.date})</Anchor>
            </Link>
          ) : null}

          {
            gallery ? (
              <Link to={`/galeries/${gallery?.id}`}
                    key={"ID"}><Anchor>{gallery?.title} ({gallery?.date})</Anchor>
              </Link>
            ) : null
          }
        </Breadcrumbs>

        <Flex justify="space-between" align="flex-start" mt="md">
          <Box>
            <Title order={1} size="1.5rem" fw="bold">{gallery?.title ?? "Galerie"}</Title>
            <Text>{gallery?.date}</Text>
            {
              gallery?.hide_date ? (<Badge color="red">Schovat datum</Badge>) : null
            }
            {
              gallery?.hide_from_users ? (<Badge color="red">ADMIN ONLY</Badge>) : null
            }
          </Box>
          <Group gap="xs">
            {
              selection.selectMode ? (
                <Button mb="md" color="gray" variant="light" onClick={selection.clear}>Zrušit výběr</Button>
              ) : (
                <>
                  <Button mb="md" color="gray" variant="light" onClick={() => selection.setSelectMode(true)}>Přesunout</Button>
                  <Link to={"reorder"}>
                    <Button mb="md" color="gray" variant="light">Přeřadit</Button>
                  </Link>
                  <Link to={"upload"}>
                    <Button mb="md" color="green">+ Nahrát fotky a videa</Button>
                  </Link>
                </>
              )
            }
          </Group>
        </Flex>

        {
          photos.isError ? (
            <Alert variant="light" color="red" title="Chyba" icon={<IconInfoCircle/>}>
              Nepodařilo se načíst data
            </Alert>
          ) : null
        }

        <ScrollArea>
          <Flex mt={20} gap={10}>
            {
              gallery?.sub_galleries?.map((gallery, index) => (
                  <GalleryCard gallery={gallery} key={gallery.id}/>
                )
              )
            }
          </Flex>
        </ScrollArea>

        <VideoRow galleryId={id} slug={photos?.data?.slug || ""} videos={photos.data?.videos || []}
                  selectMode={selection.selectMode}
                  selectedVideos={selection.selectedVideos}
                  onToggleVideo={selection.toggleVideo}/>

        <div>
          <PhotoAlbumView galleryId={id} slug={photos?.data?.slug || ""} photos={photos.data?.photos || []}
                          selectMode={selection.selectMode}
                          selectedPhotos={selection.selectedPhotos}
                          onTogglePhoto={selection.togglePhoto}/>
        </div>

        {
          photos.isFetching ? (
            <Group justify="center" gap="sm" mt="xl">
              <Loader color="lime" size="lg" type="dots"/>
            </Group>
          ) : null
        }

        <EmptyState isEmpty={!photos?.data?.photos?.length && !photos?.data?.videos?.length} isLoading={photos.isLoading}/>

        <CreateModal upperId={id} gallery={gallery}/>
      </Container>

      {
        selection.selectMode && selection.count > 0 ? (
          <>
            <Box style={{height: 72}}/>
            <div className={moveClasses.actionBar}>
              <Container size="md">
                <Group justify="space-between">
                  <Text fw={600}>Vybráno {selection.count} položek</Text>
                  <Group gap="xs">
                    <Button color="gray" variant="light" onClick={selection.clear}>Zrušit</Button>
                    <Button color="green" onClick={openMove}>Přesunout</Button>
                  </Group>
                </Group>
              </Container>
            </div>
          </>
        ) : null
      }

      <MoveModal
        opened={moveOpened}
        onClose={closeMove}
        sourceId={id}
        selectedPhotos={selection.selectedPhotos}
        selectedVideos={selection.selectedVideos}
        onMoved={selection.clear}
      />
    </>
  )
}

export default GalleryDetail
